// extracted by mini-css-extract-plugin
export var attribution = "_8o-4";
export var authorName = "_8o-5";
export var quote = "_8o-3";
export var testimonial = "_8o-2";
export var trustedBy = "_8o-0";
export var trustedByLabel = "_8o-1";